import React, { useEffect } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import DialogList from 'src/dialogs';

interface ITransferExpenseDialogProps {
    dialogName: string;
    officeExpense: { expenseCategery: string, expenseValue: string};
    onSubmit?: (userName: string, password: string) => void;
    hideDialog: () => void;
    showDialog: (dialogName: DialogList) => void;
}

const TransferExpenseDialog = (props: ITransferExpenseDialogProps) => {
    const { register, errors, getValues } = useForm();

    useEffect(() => {
        onCreate();
    }, []);

    const onCreate = () => {
        console.log('ReportOptionsDialog onCreate()');
    };

    const OKClicked = () => {
        let data = getValues();
        props.onSubmit(data.userName, data.password);
        props.hideDialog();
    };

    const officeExpenseToOptions = (): { value: string; label: string }[] => {
        return [
            {value: 'oneThousandTwoAs', label: '1002As'},
            {value: 'abstractFees', label: 'Abstract Fees'},
            {value: 'bankCharges', label: 'Bank Charges'},
            {value: 'copies', label: 'Copies'},
            {value: 'discount', label: 'Discount'},
            {value: 'draft', label: 'Draft Ext'},
            {value: 'fax', label: 'Fax'},
            {value: 'formsAndSupplies', label: 'Forms & Supplies'},
            {value: 'maps', label: 'Maps'},
            {value: 'notory', label: 'Notory'},
            {value: 'officeCopies', label: 'Office Copies'},
            {value: 'phone', label: 'Phone'},
            {value: 'postage', label: 'Postage'},
            {value: 'shipping', label: 'Shipping Expenses'},
            {value: 'other', label: 'Subscriptions'}
        ];
    };

    return (
        <Dialog title="Transfer Expense" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '30%' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <form>
                    <label style={{ marginBottom: '.5rem'}}>From Expense: <b>{props?.officeExpense?.expenseCategery}</b></label>
                    <RHFInputBox
                        label="Amount"
                        labelOnLeft={true}
                        labelStyle={{ width: '15rem'}}
                        defaultVal={props?.officeExpense?.expenseValue}
                        name={`expenseAmount`}
                        type="text"
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '50%' }}
                    />
                    <RHFSelect
                        label="Transfer to:"
                        labelOnLeft={true}
                        labelStyle={{ width: '12rem'}}
                        name={`password`}
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '75%' }}
                        options={officeExpenseToOptions()}
                    />
                    <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                        <Button
                            className="blue-hover-button"
                            style={{ width: '24%', marginRight: '1rem' }}
                            text={'Transfer'}
                            onClick={() => OKClicked()}
                        />
                        <Button
                            className="blue-hover-button"
                            style={{ width: '24%', marginRight: '1rem' }}
                            text={'Cancel'}
                            onClick={() => props.hideDialog()}
                        />
                    </div>
                </form>
            </div>
        </Dialog>
    );
};

export default TransferExpenseDialog;



// WEBPACK FOOTER //
// ./src/components/accounts-payable/dialogs/TransferExpenseDialog.tsx